import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/user'
import './style.css'

const root = document.getElementById('app')
if (!root) throw new Error('Root element #app not found')

try {
  const app = createApp(App)
  const pinia = createPinia()
  app.use(pinia)
  app.use(router)

  // Inicializar usuario desde localStorage (puede fallar si hay datos corruptos)
  const userStore = useUserStore()
  userStore.initUser()

  app.mount('#app')
} catch {
  root.innerHTML =
    '<div style="padding:2rem;font-family:system-ui;text-align:center;color:#666;">' +
    '<p style="color:#c00;margin-bottom:1rem;">The application could not be loaded.</p>' +
    '<p><a href="/" style="color:#EDD97A;">Back to home</a> or reload the page.</p>' +
    '</div>'
}

